module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "profile"
  }, [_c('div', {
    staticClass: "nav"
  }, [_c('el-menu', {
    staticClass: "theme-primary",
    attrs: {
      "default-active": _vm.$route.path,
      "router": ""
    }
  }, [_c('el-menu-item', {
    attrs: {
      "index": "/profile"
    }
  }, [_vm._v("账户概况")]), _vm._v(" "), (_vm.apiEnabled) ? _c('el-menu-item', {
    attrs: {
      "index": "/profile/development"
    }
  }, [_vm._v("开发信息")]) : _vm._e()], 1)], 1), _vm._v(" "), _c('router-view', {
    staticClass: "sub-profile"
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-b82a1e50"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/profile/index.vue
// module id = 943
// module chunks = 3